import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { useContext, useReducer, useState } from "react";
import { Collapse } from "react-bootstrap";
import PerfectScrollbar from "react-perfect-scrollbar";
import { Link, useLocation } from "react-router-dom";
import { ThemeContext } from "../../../context/ThemeContext";
import {
  SupervisorMenuList,
  TellerMenuList,
  VaultManagerMenuList,
} from "./Menu";

const reducer = (previousState, updatedState) => ({
  ...previousState,
  ...updatedState,
});

const initialState = {
  active: "",
  activeSubmenu: "",
};

const SideBar = () => {
  var d = new Date();
  const {
    iconHover,
    sidebarposition,
    headerposition,
    sidebarLayout,
    ChangeIconSidebar,
  } = useContext(ThemeContext);

  const [state, setState] = useReducer(reducer, initialState);

  let handleheartBlast = document.querySelector(".heart");
  function heartBlast() {
    return handleheartBlast.classList.toggle("heart-blast");
  }

  const [hideOnScroll, setHideOnScroll] = useState(true);
  useScrollPosition(
    ({ prevPos, currPos }) => {
      const isShow = currPos.y > prevPos.y;
      if (isShow !== hideOnScroll) setHideOnScroll(isShow);
    },
    [hideOnScroll],
  );

  const handleMenuActive = (status) => {
    setState({ active: status });
    if (state.active === status) {
      setState({ active: "" });
    }
  };
  const handleSubmenuActive = (status) => {
    setState({ activeSubmenu: status });
    if (state.activeSubmenu === status) {
      setState({ activeSubmenu: "" });
    }
  };
  // Menu dropdown list End

  const location = useLocation();
  const path = location.pathname;

  const isActiveMatch = (item) => {
    if (item.to === path) return true;
    if (item.content) {
      return item.content.some((subItem) => isActiveMatch(subItem));
    }
    return false;
  };

  const userRole = localStorage.getItem("userRole");
  const MenuList =
    userRole === "Vault Manager"
      ? VaultManagerMenuList
      : userRole === "Supervisor"
        ? SupervisorMenuList
        : TellerMenuList;

  return (
    <div className="deznav">
      <PerfectScrollbar className="deznav-scroll">
        <ul className="metismenu" id="menu">
          {MenuList.map((data, index) => {
            let menuClass = data.classsChange;
            if (menuClass === "menu-title") {
              return (
                <li className={menuClass} key={index}>
                  {data.title}
                </li>
              );
            } else {
              const itemActive = isActiveMatch(data);
              return (
                <li
                  className={`mb-2 ${state.active === data.title || itemActive ? "mm-active" : ""}`}
                  key={index}
                >
                  {data.content && data.content.length > 0 ? (
                    <>
                      <Link
                        to={"#"}
                        className="has-arrow d-flex align-items-center gap-3"
                        onClick={() => {
                          handleMenuActive(data.title);
                        }}
                      >
                        {data.iconStyle}
                        <span className={`nav-text ${itemActive ? "text-primary" : ""}`}>
                          {data.title}
                        </span>
                      </Link>
                      <Collapse
                        in={
                          state.active === data.title || itemActive
                            ? true
                            : false
                        }
                      >
                        <ul
                          className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}
                        >
                          {data.content &&
                            data.content.map((subData, index) => {
                              const subActive = isActiveMatch(subData);
                              return (
                                <li
                                  key={index}
                                  className={`${state.activeSubmenu === subData.title || subActive ? "mm-active" : ""}`}
                                >
                                  {subData.content &&
                                  subData.content.length > 0 ? (
                                    <>
                                      <Link
                                        to={subData.to}
                                        className={
                                          subData.hasMenu ? "has-arrow" : ""
                                        }
                                        onClick={() => {
                                          handleSubmenuActive(subData.title);
                                        }}
                                      >
                                        {subData.title}
                                      </Link>
                                      <Collapse
                                        in={
                                          state.activeSubmenu ===
                                            subData.title || subActive
                                            ? true
                                            : false
                                        }
                                      >
                                        <ul
                                          className={`${menuClass === "mm-collapse" ? "mm-show" : ""}`}
                                        >
                                          {subData.content &&
                                            subData.content.map(
                                              (childData, index) => {
                                                return (
                                                  <li key={index}>
                                                    <Link
                                                      className={`${path === childData.to ? "mm-active" : ""}`}
                                                      to={childData.to}
                                                    >
                                                      {childData.title}
                                                    </Link>
                                                  </li>
                                                );
                                              },
                                            )}
                                        </ul>
                                      </Collapse>
                                    </>
                                  ) : (
                                    <Link
                                      className={`${path === subData.to ? "mm-active" : ""}`}
                                      to={subData.to}
                                    >
                                      {subData.title}
                                    </Link>
                                  )}
                                </li>
                              );
                            })}
                        </ul>
                      </Collapse>
                    </>
                  ) : (
                    <Link
                      className={`d-flex align-items-center gap-3 ${path === data.to ? "mm-active" : ""}`}
                      to={data.to}
                    >
                      {data.iconStyle}
                      <span className={`nav-text ${path === data.to ? "text-primary" : ""}`}>
                        {data.title}
                        {data.badge && (
                          <span
                            className="badge text-white rounded-circle d-inline-flex align-items-center justify-content-center p-0 ms-2"
                            style={{
                              backgroundColor:
                                data.badgeColor || "var(--primary)",
                              width: "20px",
                              height: "20px",
                              fontSize: "10px",
                              fontWeight: "bold",
                              verticalAlign: "text-bottom",
                            }}
                          >
                            {data.badge}
                          </span>
                        )}
                      </span>
                    </Link>
                  )}
                </li>
              );
            }
          })}
        </ul>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
